'use client';

import Link from 'next/link';
import { FC, useState } from 'react';
import type { ProductCategory } from '@hyex/dxp/types/store/Product/ProductCategory';
import { BlogCategory } from '@hyex/dxp/types/blog/Category';
import clsx from 'clsx';

type PossibleTypes = ProductCategory | BlogCategory;

type CommonProps<T extends PossibleTypes> = {
  isMobile: boolean;
  slug?: string;
  baseHref: string;
  indexHref?: string;
  subHref?: string;
  items: T[];
  fieldName: keyof T;
};

const NavCarousel = <T extends PossibleTypes>({
  isMobile,
  items,
  slug,
  baseHref,
  subHref,
  indexHref,
  fieldName,
}: CommonProps<T>) => {
  const styles = {
    mobile: 'embla-slide categories-nav-item',
    desktop: 'categories-nav-item',
  };

  const [previousSlug, setPreviousSlug] = useState(slug);

  const combinedClassName = `${isMobile ? styles.mobile : styles.desktop} carousel-categories`;

  const href = (item: T) => {
    if (item.value === previousSlug) return indexHref ? indexHref : baseHref;

    const fullPath = `${baseHref}/${subHref}/${item.value}`;

    const partPath = `${baseHref}/${item.value}`;

    return subHref ? fullPath : partPath;
  };

  if (!items || items.length === 0) {
    return <></>;
  }

  //slug === item.value ? 'active' : ''
  return (
    <>
      {items.map((item, i) =>
        item ? (
          <div key={i} className={combinedClassName}>
            <Link
              href={href(item)}
              className={clsx('category-link', { active: slug === item.value })}
            >
              <>{item[fieldName]}</>
            </Link>
          </div>
        ) : null
      )}
    </>
  );
};

export default NavCarousel;
